module.exports = __webpack_public_path__ + "static/img/14.4422e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/14.jpg
// module id = 3uMc
// module chunks = 0